import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Gallery } from '../components/Gallery/Gallery';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Faq } from '../components/Faq';
import { ServiceAreas } from '../components/ServiceAreas';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { MobileCallBar } from '../components/MobileCallBar';
import { useLanguage } from '../hooks/useLanguage';
import { ui } from '../data/translations';
export function Home() {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    document.title = t(ui.seo.title);
    setMeta('description', t(ui.seo.description));
    setMeta('keywords', 'concrete work, asphalt paving, construction services, concrete contractor, asphalt contractor, professional services');
  }, [t]);
  return <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-254" data-mp="2vxyceq8rmagf">
      <Header data-id="element-255" data-mp="2vvlugd30c03d" />
      <main data-id="element-256" data-mp="2qylpy6lt35ed">
        <Hero data-id="element-257" data-mp="2qybysfp0ys73" />
        <Services data-id="element-258" data-mp="2qxu3bla6si08" />
        <Process data-id="element-259" data-mp="2qxakm2cpppl5" />
        <Testimonials data-id="element-260" data-mp="2qwsiip3dch5b" />
        <Gallery data-id="element-261" data-mp="2mx0gywce7b9g" />
        <WhyChooseUs data-id="element-262" data-mp="2mxjnlgwled86" />
        <Faq data-id="element-263" data-mp="2mvyu7um0l0bw" />
        <ServiceAreas data-id="element-264" data-mp="2mwgxvcb0agtu" />
        <Contact data-id="element-265" data-mp="2mz33h6ec6m9f" />
      </main>
      <Footer data-id="element-266" data-mp="2hxnljn7ggvv9" />
      <MobileCallBar data-id="element-267" data-mp="2hy70cv1t7452" />
    </div>;
}
function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = name;
    document.head.appendChild(tag);
  }
  tag.content = content;
}